
export const language = {
  home: 'Trang chủ',
  general: 'Chức năng chung',
  plan: 'Kế hoạch',
  calendar: 'Lịch công tác',
  calendar_units: 'Lịch các đơn vị',
  calendar_main: 'Lịch cá nhân',
  list_users: 'Danh sách người sử dụng',
  report_users_action: 'Thống kê người xử lý',
  diendan: 'Diễn đàn',
  save: 'Lưu',
  add: 'Thêm mới',
  update: 'Sửa',
  delete: 'Xóa',
  refresh: 'Làm mới',
  danhmuc: 'Danh mục',
  chucvu: ' Chức vụ',
  donvingoai: 'Đơn vị ngoài',
  nhommauvanban: 'Nhóm mẫu văn bản',
  nhomtintuc: 'Nhóm tin tức',
  loaikehoach: 'Loại kế hoạch',
  linhvucvanban: 'Lĩnh vực văn bản',
  loaivanban: 'Loại văn bản',
  domat: 'Độ mật',
  dokhan: 'Độ khẩn',
  thietbi: 'Thiết bị',
  admin: 'Hệ thống',
  danhsachnguoidung: 'DS người dùng',
  danhsachtaikhoan: 'DS tài khoản',
  phanquyen: 'Phân quyền',
  cauhinhhethong: 'Cấu hình hệ thống',
  danhmucsovanthu: 'Danh mục số văn thư',
  nhomchung: 'Nhóm chung',
  donvinoibo: 'Đơn vị nội bộ',
  thongtinhotro: 'Thông tin hỗ trợ',
  quanlyquyenhan: 'Quản lý quyền hạn',
  hosocongviec: 'Hồ sơ công việc',
  hosocanhan: 'Hồ sơ cá nhân',
  hosodonvi: 'Hồ sơ đơn vị',
  tainguyen: 'Tài nguyên',
  vanbanphapquy: 'Văn bản pháp quy',
  vanbanphocap: 'Văn bản phổ cập',
  mauvanban: 'Mẫu văn bản',
  datxe: 'Đặt xe',
  danhmucxe: 'Danh mục xe',
  xemketquaduyet: 'Xem kết quả duyệt',
  theodoiyeucau: 'Theo dõi yêu cầu',
  dangkylich: 'Đăng ký lịch',
  danhmucloaiphong: 'Danh mục loại phòng',
  danhmuctoanha: 'Danh mục tòa nhà',
  danhmucphonghop: 'Danh mục phòng họp',
  xemketqualichphong: 'Xem kết quả xếp lịch phòng',
  sapxeplich: 'Sắp xếp lịch',
  theodoidatlich: 'Theo dõi đặt lịch',
  vanbanden: 'Văn bản đến',
  vanbandi: 'Văn bản đi',
  stt: 'STT',
  tenchucvu: 'Tên chức vụ',
  tenviettat: 'Tên viết tắt',
  action: 'Thao tác',
  is_required: 'không được trống',
  add_success_record: 'Đã thêm mới dữ liệu thành công!',
  update_success_record: 'Đã sửa thông tin dữ liệu thành công!',
  delete_success_record: 'Đã xóa thông tin dữ liệu thành công!',
  message: 'Thông báo',
  error: 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại!',
  is_format_number: 'phải là kiểu số',
  yes: 'Đồng ý',
  no: 'Hủy',
  close: 'Đóng',
  confirm_delete_question: 'Bạn muốn xóa thông tin bản ghi này',
  next: 'Tiếp',
  previous: 'Lùi',
  first: 'Về đầu',
  last: 'Cuối',
  page: 'Trang',
  total_page: 'Tổng số trang',
  title_header: 'EGOV',
  footer_name: 'EGOV 4.0 Copyright 2020-2025.',
  news: 'Tin tức',
  giaiquyetsuvu: 'Giải quyết sự vụ',
  dashboard: 'Bảng điều khiển',
  setting: 'Cấu hình',
  tendokhan: 'Tên độ khẩn',
  tendomat: 'Tên độ mật',
  tennhommauvanban: 'Tên nhóm mẫu văn bản',
  tenkehoach: 'Tên kế hoạch',
  tenloaivanban: 'Tên loại văn bản',
  tenlinhvuc: 'Tên lĩnh vực',
  tenhomtintuc: 'Tên nhóm tin tức',
  tenthietbi: 'Tên thiết bị',
  ghichu: 'Ghi chú',
  loaiphong: 'Loại phòng',
  toanha: 'Tòa nhà',
  tenloaiphong: 'Tên loại phòng',
  tentoanha: 'Tên tòa nhà',
  phong: 'Phòng',
  tenphong: 'Tên phòng',
  succhua: 'Sức chứa',
  select: 'Chọn',
  chucnangchung: 'Chức năng chung',
  lichdonvi: 'Lịch đơn vị',
  lichcanhan: 'Lịch cá nhân',
  lichcongtac: 'Lịch công tác',
  tendonvi: 'Tên đơn vị',
  quanlyhethong: 'Quản lý hệ thống',
  sovanthu: 'Sổ văn thư',
  tensovanthu: 'Tên sổ văn thư',
  sovaoso: 'Số vào sổ',
  kyhieuvanban: 'K/H văn bản',
  nguoiquanlyso: 'QL sổ',
  donviquanlyso: 'Đơn vị quản lý sổ',
  quantrihethong: 'Quản trị hệ thống',
  dmsovanthu: 'Danh mục sổ văn thư',
  sudung: 'Sử dụng',
  dvqlso: 'Đ/V QL sổ',
  message_on: 'Đã kích hoạt thành công',
  message_off: 'Đã ngừng kích hoạt thành công',
  message_add_sovanthu_donvi_success: 'Đã cập nhật đơn vị sử dụng sổ văn thư thành công!',
  tenhoso: 'Tên hồ sơ',
  nguoitao: 'Người tạo',
  ngaytao: 'Ngày tạo',
  loaihoso: 'Loại hồ sơ',
  noidung: 'Nội dung',
  hosophocap: 'Hồ sơ phổ cập',
  filedinhkem: 'File đính kèm',
  dropfileupload: 'Kéo thả file đính kèm vào đây',
  uploadfile: 'Tải file đính kèm',
  deleteall: 'Xóa tất cả',
  sohieugoc: 'Số hiệu gốc',
  ngayvaoso: 'Ngày vào sổ',
  ngayky: 'Ngày ký',
  trichyeu: 'Trích yếu',
  noigoiphathanh: 'Nơi gửi/phát hành',
  luotnguoidoc: 'Lượt người đọc',
  tenvanban: 'Tên văn bản',
  search: 'Tìm kiếm',
  kehoach: 'Kế hoạch',
  totrinh: 'Tờ trình',
  trinh: 'Trình (Báo cáo)',
  soantotrinh: 'Soạn tờ trình',
  xulytotrinhgui: 'Xử lý tờ trình gửi',
  xulytotrinhnhan: 'Xử lý tờ trình nhận',
  totrinhdangsoan: 'Tờ trình đang soạn',
  giaoviec: 'Giao việc (yêu cầu)',
  soangiaoviecmoi: 'Soạn giao việc mới',
  xulygiaoviecgui: 'Xử lý giao việc gửi',
  xulygiaoviecnhan: 'Xử lý giao việc nhận',
  giaoviecdangsoan: 'Giao việc đang soạn',
  homthunoibo: 'Hòm thư nội bộ',
  hoptraodoithongtin: 'Họp - Trao đổi thông tin',
  taomoi: 'Tạo mới',
  thamgiahop: 'Tham gia họp',
  thongbao: 'Thông báo',
  docthongbao: 'Đọc thông báo',
  taomoithongbao: 'Tạo mới thông báo',
  sovanbanden: 'Sổ văn bản đến',
  vaosovanbanden: 'Vào sổ văn bản đến',
  vanbandenchogiaoxuly: 'Văn bản đến chờ giao xử lý',
  vanbandendavaoso: 'Văn bản đến đã vào sổ',
  insocongvanden: 'In sổ công văn đến',
  quanlyso: 'Quản lý sổ',
  xulyvanbanden: 'Xử lý văn bản đến',
  tatcavanbanden: 'Tất cả văn bản đến',
  vanbanchuaxuly: 'Văn bản chưa xử lý',
  vanbandangxuly: 'Văn bản đang xử lý',
  vanbandahoanthanh: 'Văn bản đã hoàn thành',
  giaoviecnhanh: 'Giao việc nhanh',
  giaoxulyvanban: 'Giao xử lý văn bản',
  chogiaoxuly: 'Chờ giao xử lý',
  quanlyphocap: 'Quản lý phổ cập',
  sovanbandi: 'Sổ văn bản đi',
  vaosovanbandi: 'Vào sổ văn bản đi',
  vanbandichogiaoxuly: 'Văn bản đi chờ giao xử lý',
  vanbandidavaoso: 'Văn bản đi đã vào sổ',
  insocongvandi: 'In sổ công văn đi',
  xulyvanbandi: 'Xử lý văn bản đi',
  vanbandiduocxem: 'Văn bản đi được xem',
  chude: 'Chủ đề',
  trangthai: 'Trạng thái',
  thoigiangui: 'Thời gian gửi',
  thoihan: 'Thời hạn',
  danhsachtotrinh_baocaogui: 'Danh sách tờ trình báo cáo gửi',
  danhsachtotrinh_baocaonhan: 'Danh sách tờ trình báo cáo nhận',
  danhsachtotrinh_baocaodangsoan: 'Danh sách tờ trình báo cáo đang soạn',
  danhsachgiaoviec_yeucaugui: 'Danh sách giao việc, yêu cầu gửi',
  danhsachgiaoviec_yeucaunhan: 'Danh sách giao việc, yêu cầu nhận',
  danhsachgiaoviec_dangsoan: 'Danh sách giao việc đang soạn',
  chophepthamkhaoykien: 'Cho phép tham khảo ý kiến',
  danhsachthongbao: 'Danh sách thông báo',
  thoigianphathanh: 'Thời gian phát hành',
  ngayhethieuluc: 'Ngày hết hiệu lực',
  ngaycohieuluc: 'Ngày có hiệu lực',
  chuyentrinh: 'Chuyển trình',
  chuyengiaoviec: 'Chuyển giao việc',
  chenhoso: 'Chèn hồ sơ',
  file: 'File',
  all: 'Tất cả',
  chuaxemykien: 'Chưa xem ý kiến',
  daxemykien: 'Đã xem ý kiến',
  chuaxuly: 'Chưa xử lý',
  dangxuly: 'Đang xử lý',
  hoanthanh: 'Hoàn thành',
  tongso: 'Tổng số',
  nguoigui: 'Người gửi',
  thoigian: 'Thời gian',
  yeucau: 'Yêu cầu',
  thoigiannhan: 'Thời gian nhận',
  daphocap: 'Đã phổ cập',
  chuaphocap: 'Chưa phổ cập',
  tukhoa: 'Từ khóa',
  ngaynhan: 'Ngày nhận',
  noiphathanh: 'Nơi phát hành',
  nguoiky: 'Người ký',
  vanban: 'Văn bản',
  giaoxuly: 'Giao xử lý',
  phocap: 'Phổ cập',
  huyphocap: 'Hủy phổ cập',
  danhsachvanbanden_chogiaoxuly: 'Danh sách văn bản đến chờ giao xử lý',
  danhsachvanbanden_davaoso: 'Danh sách văn bản đến đã vào sổ',
  danhsachvanbanden_chuaxuly: 'Danh sách văn bản đến chưa xử lý',
  danhsachvanbanden_dangxuly: 'Danh sách văn bản đến đang xử lý',
  danhsachvanbanden_hoanthanh: 'Danh sách văn bản đến đã hoàn thành',
  thongtinvanbanden: 'Thông tin văn bản đến',
  danhsachvanbandi_chogiaoxuly: 'Danh sách văn bản đi chờ giao xử lý',
  danhsachvanbandi_davaoso: 'Danh sách văn bản đi đã vào sổ',
  thongtinvanbandi: 'Thông tin văn bản đến',
  totrinhgui_chuaxuly: 'Tờ trình/ báo cáo gửi chưa xử lý',
  totrinhgui_dangxuly: 'Tờ trình/ báo cáo gửi đang xử lý',
  totrinhnhan_chuaxuly: 'Tờ trình/ báo cáo nhận chưa xử lý',
  totrinhnhan_dangxuly: 'Tờ trình/ báo cáo nhận đang xử lý',
  yeucaugui_chuaxuly: 'Giao việc/ yêu cầu gửi chưa xử lý',
  yeucaugui_dangxuly: 'Giao việc/ yêu cầu gửi đang xử lý',
  yeucaunhan_chuaxuly: 'Giao việc/ yêu cầu nhận chưa xử lý',
  yeucaunhan_dangxuly: 'Giao việc/ yêu cầu nhận đang xử lý',
  totrinhgui: 'Tờ trình gửi',
  totrinhnhan: 'Tờ trình nhận',
  yeucaugui: 'Yêu cầu gửi',
  yeucaunhan: 'Yêu cầu nhận',
  email: 'Thư điện tử',
  thunhan: 'Thư nhận',
  thudi: 'Thư đi',
  thudangsoan: 'Thư đang soạn',
  thongtinmoihop: 'Thông tin mời họp',
  huongdansudung: 'Hướng dẫn sử dụng',
  thudanhan: 'Thư nhận',
  thudagui: 'Thư đã gửi',
  thudadoc: 'Thư nhận đã đọc',
  thuchuadoc: 'Thư nhận chưa đọc',
  thudaxoa: 'Thư nhận đã xóa',
  nguoinhan: 'Người nhận',
  danhsachthu_dagui: 'Danh sách thư đã gửi',
  danhsachthu_danhan: 'Danh sách thư nhận',
  danhsachthu_daxoa: 'Danh sách thư nhận đã xóa',
  danhsachthu_chuadoc: 'Danh sách thư nhận chưa đọc',
  danhsachthu_dadoc: 'Danh sách thư nhận đã đọc',
  danhsachthu_dangsoan: 'Danh sách thư đang soạn',
  main: 'Bảng điều khiển',
  chonnguoinhan: 'Chọn người nhận',
  thongtinchung: 'Thông tin chung',
  luuthongtin: 'Lưu thông tin',
  danhsachdonvi: 'Danh sách đơn vị',
  danhsachchon: 'Danh sách chọn',
  soanyeucau: 'Soan giao việc',
  luunhap: 'Lưu nháp',
  send: 'Gửi',
  soanthao: 'Soạn thảo',
  khongxuly: 'Không xử lý',
  status_6: 'Phổ cập, không giao, lưu hệ thống',
  status_7: 'Gửi đích danh',
  status_8: 'Trả lại văn thư',
  status_9: 'Chờ giao xử lý',
  message_error_login: 'Thông tin tên đăng nhập và mật khẩu không đúng!',
  message_success_login: 'Bạn đã đăng nhập thành công!',
  login: 'Đăng nhập',
  send_success_record: 'Đã gửi thông tin thành công!',
  chonnguoidoc: 'Chọn người đọc',
  nguoinhap: 'Người nhập',
  danhsachcuochop: 'Danh sách cuộc họp, trao đổi thông tin, tọa đàm',
  nguoichutri: 'Người chủ trì',
  thoigianbatdau: 'Thời gian bắt đầu',
  meeting: 'Cuộc họp',
  taocuochopmoi: 'Tạo cuộc họp mới',
  kichhoatthamkhao: 'Kích chọn để không cho phép các thành viên tham khảo ý kiến',
  chonnguoihop: 'Chọn người họp',
  ykientonghop: 'Ý kiến tổng hợp',
  chonnoigui: 'Chọn nơi gửi',
  chonnguoiky: 'Chọn người ký',
  chondonvinhan: 'Chọn đơn vị nhận',
  donvinhan: 'Đơn vị nhận',
  hoten: 'Họ và tên',
  bochon: 'Bỏ chọn',
  thoihannhacviec: 'Thời hạn nhắc việc',
  nguoigiaohoanthanh: 'Người giao hoàn thành luôn',
  theodoixulydencapnhan: 'Theo dõi xử lý đến cấp nhận giao tiếp',
  dagiaoxulythanhcong: 'Đã giao xử lý thành công!',
  gandocvanban: 'Gán đọc văn bản',
  messagechonnguoidoc: 'Vui lòng chọn người đọc!',
  questionphocap: 'Bạn muốn phổ cập văn bản?',
  questionhuyphocap: 'Bạn muốn hủy phổ cập văn bản',
  messagephocap: 'Bạn đã phổ cập văn bản thành công!',
  messagehuyphocap: 'Bạn đã hủy phổ cập văn bản thành công',
  message_warning_phocap: 'Vui lòng chọn văn bản cần phổ cập!',
  message_warning_huyphocap: 'Vui lòng chọn văn bản cần hủy phổ cập',
  xulyhoso: 'Xử lý hồ sơ',
  dinhkemfilevanbanhoso: 'Đính kèm file văn bản vào hồ sơ',
  dadinhkemfilevaohosothanhcong: 'Đã đính kèm file vào hồ sơ thành công',
  vanbannoibo: 'Văn bản nội bộ',
  vanbandoingoai: 'Văn bản đối ngoại',
  nhomvanban: 'Nhóm văn bản',
  hienthi: 'Hiển thị',
  tenfile: 'Tên file',
  kichthuoc: 'Kích thước',
  soanthumoi: 'Soạn thư mới',
  xulytotrinh: 'Xử lý tờ trình',
  nguoitrinh: 'Người trình',
  month: 'Tháng',
  week: 'Tuần',
  day: 'Ngày',
  today: 'Hôm nay',
  thu: 'Thư',
  xoamucchon: 'Xóa mục chọn',
  confirm_delete_question_all: 'Bạn muốn xóa tất cả?',
  confirm_delete_question_check: 'Bạn muốn xóa các bản ghi đã chọn?',
  confirm_read_question_check: 'Bạn muốn đánh đấu chưa đọc các bản ghi đã chọn?',
  read_success_record: 'Đã dánh dấu thành công!',
  read_check: 'Đánh dấu chưa đọc',
  gui: 'Gửi',
  nhan: 'Nhận',
  davaoso: 'Đã vào sổ',
  chuaxem: 'Chưa xem',
  account: 'Tài khoản',
  thongtincanhan: 'Thông tin cá nhân',
  thongkexuly: 'Thống kê xử lý',
  doimatkhau: 'Đổi mật khẩu',
  thoat: 'Thoát khỏi chương trình',
  bieudototrinh: 'Biểu đồ xử lý tờ trình',
  bieudoyeucau: 'Biểu đồ xử lý yêu cầu (giao việc)',
  nhanchuaxem: 'Nhận chưa xem',
  bieudovanbanden: 'Biểu đồ văn bản đến',
  bieudoxulyvanbanden: 'Biểu đồ xử lý văn bản đến',
  bieudovanbandi: 'Biểu đồ văn bản đi',
  bieudoxulyvanbandi: 'Biểu đồ xử lý văn bản đi',
  tungay: 'Từ ngày ',
  denngay: 'Đến ngày ',
  tugio: 'Từ giờ',
  dengio: 'Đến giờ',
  chutri: 'Chủ trì',
  diadiem: 'Địa điểm',
  mauhienthi: 'Màu hiển thị',
  phanhoi: 'Phản hồi',
  ykienxuly: 'Ý kiến xử lý',
  luuthongtinxuly: 'Lưu thông tin xử lý',
  thaythemfile: 'Thay thêm file',
  quatrinhxuly: 'Quá trình xử lý',
  change_hoanthanh_success: 'Đã chuyển trạng thái hoàn thành thành công!',
  confirm_hoanthanh_question: 'Bạn phải chắc chắn mình đã xử lý xong công việc này. Nhấn Đồng ý để xác nhận hoàn thành, Hủy để xem lại.',
  message_xuly_success: 'Đã cập nhật ý kiến xử lý thành công!',
  message_xuly_file_success: 'Đã cập nhật file đính kèm thành công!',
  confirm_save_xuly_question: 'Bạn muốn lưu ý kiến xử lý?',
  solandoc: 'Số lần đọc',
  xulyyeucau: 'Xử lý yêu cầu',
  butphe: 'Bút phê',
  butphe_add: 'Thêm thông tin bút phê',
  butphe_khac: 'Các bút phê khác',
  traloi: 'Trả lời',
  traloitatca: 'Trả lời tất cả',
  guitiep: 'Gửi tiếp',
  quanlythongbao: 'Quản lý thông báo',
  print: 'In',
  nguoidang: 'Người đăng',
  vohan: 'Vô hạn',
  soluotdoc: 'Số lượt đọc',
  ngaydang: 'Ngày đăng',
  tonghopykien: 'Tổng hợp ý kiến',
  message_ykien_success: 'Đã cập nhật ý kiến thành công!',
  guirangoai: 'Gửi ra ngoài',
  title: 'Tiêu đề',
  tacgia: 'Tác giả',
  ngayphathanh: 'Ngày phát hành',
  tomtat: 'Tóm tắt',
  nguon: 'Nguồn',
  thoigiandangky: 'Thời gian đăng ký',
  dangky: 'Đăng ký, yêu cầu',
  yeucauguidennguoiduyet: 'Yêu cầu thêm',
  ngay: 'Ngày',
  gio: 'Giờ',
  soantinbai: 'Soạn tin bài',
  tindaxuatban: 'Tin đã xuất bản',
  duyetyeucau: 'Duyệt yêu cầu',
  tonghop: 'Tổng hợp',
  choduyet: 'Chờ duyệt',
  daduyet: 'Đã duyệt',
  tuchoi: 'Từ chối',
  pheduyet: 'Phê duyệt',
  approve_success_message: 'Bạn đã phê duyệt thành công!',
  reject_success_message: 'Bạn đã từ chối thành công!',
  tennhomvanbandi: 'Tên nhóm văn bản đi',
  sokhoitaovaosodi: 'Số khởi tạo vào sổ đi',
  kyhieuvanbandi: 'Ký hiệu văn bản đi',
  dangsudung: 'Đang sử dụng',
  khongsudung: 'Không sử dụng',
  nhomvanbandi: 'Nhóm văn bản đi',
  dsnguoisudung: 'Danh sách người dùng',
  chondonvi: 'Chọn đơn vị',
  ngaysinh: 'Ngày sinh',
  gioitinh: 'Giới tính',
  nam: 'Nam',
  nu: 'Nữ',
  dienthoaicq: 'Điện thoại cơ quan',
  nharieng: 'Nhà riêng',
  didong: 'Di động',
  diachinharieng: 'Địa chỉ nhà riêng',
  solandangnhap: 'Số lần đăng nhập',
  dangnhapgannhat: ' Đăng nhập lần gần nhất vào lúc:',
  donvi: 'Đơn vị',
  thongtinkhac: 'Thông tin khác',
  hodem: 'Họ đệm',
  ten: 'Tên',
  bidanh: 'Bí danh',
  thutu: 'Thứ tự',
  donvichinhquyen: 'Đơn vị chính quyền',
  nguoisudung: 'Người sử dụng',
  chuyendonvi: 'Chuyển đơn vị',
  danhsachnguoisudung: 'Danh sách người sử dụng',
  chucvukiemnhiem: 'Chức vụ kiêm nhiệm',
  donvikiemnhiem: 'Đơn vị kiêm nhiệm',
  thongkesudung: 'Thống kê sử dụng',
  message_on_question: 'Bạn muốn kích hoạt tài khoản này?',
  message_off_question: 'Bạn muốn khóa tài khoản này?',
  tennhomquyen: 'Tên nhóm quyền',
  nhomquyen: 'nhóm quyền',
  phanquyenchonhom: 'Phân quyền cho nhóm',
  ganquyenchonguoidung: 'Gán quyền cho người dùng',
  quanlynhomquyen: 'Quản lý nhóm quyền',
  danhsachquyen: 'Danh sách quyền',
  quyenhan: 'Quyền hạn',
  message_permission_success: 'Đã cập nhật quyền hạn thành công',
  message_group_staff_success: 'Đã cập nhật thông tin người dùng cho nhóm quyền thành công!',
  tendangnhap: 'Tên đăng nhập',
  resetmatkhau: 'Reset mật khẩu',
  dangkytaikhoan: 'Đăng ký tài khoản',
  matkhau: 'Mật khẩu',
  chonnguoisudung: 'Chọn người sử dụng',
  nhaplaimatkhau: 'Nhập lại mật khẩu',
  nhaplaimatkhau_error: 'Nhập lại mật khẩu không đúng',
  profile_edit: 'Cập nhật thông tin cá nhân',
  dienthoainharieng: 'Điện thoại nhà riêng',
  anhdaidien: 'Ảnh đại diện',
  changepassword_success: ' Đã đổi mật khẩu thành công!',
  password_new: 'Mật khẩu mới',
  contact: 'Danh bạ',
  send_message: 'Gửi tin nhắn',
  input_text_chat: 'Nhập tin nhắn...',
  hotro: 'Phùng Văn Bốn',
  message_no_file_attach: 'Chưa có file đính kèm. Vui lòng tải file đính kèm!',
  nhomgui: 'Nhóm gửi',
  danhsach_donvi_nhomgui: 'Danh sách đơn vị và nhóm gửi',
  tennhom: 'Tên nhóm',
  vanbandenphocap: 'Danh sách văn bản đến phổ cập',
  daxem: 'Đã xem',
  hotro2: 'Nguyễn Vĩnh Đạt',
  error_selectnoigui: 'Vui lòng chọn nơi gửi!',
  message_question_next: 'Bạn muốn xử lý tiếp văn bản?',
  xuly_next: 'Xử lý tiếp',
  view_danhsach: 'Lịch theo danh sách',
  view_danhsach_week: 'Lịch theo danh sách tuần',
  view_calendar: 'Lịch dạng bảng',
  select_week: 'Chọn tuần xem lịch',
  select_year: 'Chọn năm',
  view_weeknext: 'Tuần sau',
  view_weekbefore: 'Tuần trước',
  week_thu: 'Thứ',
  week_gio: 'Giờ',
  year: 'Năm',
  monday: 'Thứ hai',
  tuesday: 'Thứ ba',
  wednesday: 'Thứ tư',
  thursday: 'Thứ năm',
  friday: 'Thứ sáu',
  saturday: 'Thứ bảy',
  sunday: 'Chủ nhật',
  login_sign: 'Đăng nhập hệ thống',
  forgot_password: 'Quên mật khẩu',
  hoso: 'Hồ sơ',
  tencoquan: 'Tên cơ quan',
  themdvcq: 'Thêm mới ĐVCQ',
  themdvcon: 'Thêm ĐV con',
  error_select_record: 'Vui lòng chọn bản ghi thực hiện!',
  add_folder: 'Thêm thư mục',
  add_folder_child: 'Thêm thư mục con',
  folder_manage: 'Quản lý thư mục',
  folder: 'Thư mục',
  folder_name: 'Tên thư mục',
  hoso_drive: 'Hồ sơ lưu trữ',
  confirm_save_drive: 'Bạn muốn lưu trữ vào thư mục này',
  success_save_drive: 'Đã lưu trữ file thành công!',
  drive_save: 'Lưu trữ hồ sơ',
  chondonvichuyen: 'Chọn đơn vị chuyển',
  message_error_donvichuyen: 'Vui lòng chọn đơn vị và nhân sự cần chuyển!',
  message_success_donvichuyen: 'Đã chuyển đơn vị thành công!',
  message_question_donvichuyen: 'Bạn muốn chuyển đơn vị cho danh sách nhân sự này?',
  download: 'Tải file',
  ngaysoan: 'ngày soạn',
  thoigianhoanthanh: 'Thời gian hoàn thành',
  message_gandoc_success: 'Đã gán đọc văn bản đi thành công!',
  hosochiase: 'Hồ sơ chia sẻ',
  hosoluutru: 'Hồ sơ lưu trữ',
  coquanbanhanh: 'Cơ quan ban hành',
  choncoquanbanhanh: 'Chọn cơ quan ban hành',
  sokyhieu: 'Số ký hiệu',
  sotrang: 'Số trang',
  theloai: 'Thể loại',
  sovanban: 'Số văn bản',
  chuyende: 'Chuyên đề',
  diachibaoquan: 'Địa chỉ bảo quản',
  masotailieu: 'Mã số tài liệu',
  share: 'Chia sẻ',
  message_share_hoso_success: 'Đã chia sẽ hồ sơ thành công!',
  error_select_staff_share: 'Vui lòng chọn người cần chia sẽ!',
  search_vanbanden: 'Tìm kiếm văn bản đến',
  search_vanbandi: 'Tìm kiếm văn bản đi',
  search_noidung: 'Nội dung cần tìm',
  so_trichyeu_ghichu: 'Số, trích yếu, ghi chú',
  linhvuc: 'Lĩnh vực',
  export_word: 'Xuất ra word',
  log_search: 'Lịch sử tìm kiếm',
  chat_group: 'Chat nhóm',
  question_answer: 'Hỏi đáp',
  input_test_question: 'Nhập câu hỏi...',
  send_question: 'Gửi câu hỏi',
  not_get_question: 'Câu hỏi không đúng cú pháp. Vui lòng kiểm tra lại',
  cuphap_question: 'Cú pháp hỏi đáp',
  hethong: 'Hệ thống',
  share_calendar_success: 'Đã chia sẻ lịch cá nhân thành công!',
  share_calendar: 'Chia sẻ lịch cá nhân',
  share_calendar_depart_success: 'Đã chia sẻ lịch đơn vị thành công!',
  share_calendar_depart: 'Chia sẻ lịch đơn vị',
  error_select_units_share: 'Vui lòng chọn đơn vị cần chia sẽ!',
  select_share_units: 'Chọn đơn vị chia sẻ',
  error_username_exists: 'Tên đăng nhập đã tồn tại. Vui lòng kiểm tra lại',
  thongtinhoso: 'Thông tin hồ sơ',
  thongtinmeeting: 'Thông tin cuộc họp',
  user_role_success: 'Đã phân quyền người dùng thành công!',
  password_empty_message: 'Mật khẩu không được trống!',
  mail_to: 'Đến',
  mail_draft: 'Soạn thư',
  back: 'Quay lại',
  mail_from: 'Từ',
  message_not_permission: 'Bạn không có quyền truy cập chức năng này',
  phatbieu_ykien: 'Phát biểu ý kiến',
  message_phatbieu_ykien: 'Đã cập nhật thông tin phát biểu ý kiến thành công!',
  ketthuc: 'Kết thúc',
  error_not_message: 'Vui lòng nhập thông tin ý kiến',
  phatbieu: 'Phát biểu',
  cho_phep_thamkhao_ykien: 'Cho phép tham khảo ý kiến',
  khong_cho_phep_thamkhao_ykien: 'Không cho phép tham khảo ý kiến',
  lan_xem_dau_tien: 'Lần xem đầu tiên:',
  lan_xem_cuoi_cung: 'Lần xem cuối cùng:',
  tim_nang_cao: 'Tìm kiếm nâng cao',
  tim_don_gian: 'Tìm đơn giản',
  not_permission_read_thongbao: 'Bạn không có quyền đọc thông báo này!',
  chon_chucvu: 'Chọn Chức vụ',
  tccs_hotro1: 'Đ/c Bình',
  tccs_hotro2: 'Lê Phạm Tuấn Vinh',
  dangthaoluan: 'Đang thảo luận',
  ykienpheduyet: 'Ý kiến phê duyệt',
  message_error_approve: 'Thông tin đã được phê duyệt!',
  thongtin_dangky: 'Thông tin đăng ký',
  ykien_pheduyet: 'Ý kiến phê duyệt',
  message_permission_kehoach: 'Bạn không có quyền xem kế hoạch!',
  xuly_mail: 'Xử lý thư',
  thungrac: 'Thùng rác',
  message_restore_mail: 'Đã phục hồi thư xóa thành công!',
  question_restore_mail: 'Bạn muốn phục hồi thư đã xóa?',
  restore: 'Phục hồi',
  restore_all: 'Phục hồi tất cả',
  question_restore_all_mail: 'Bạn muốn phục hồi tất cả thư đã xóa?',
  danhsach_thuguixoa: 'Danh sách thư gửi đã xóa',
  chuyen_thungrac: 'Chuyển vào thùng rác',
  chuyen_thungrac_all: 'Chuyển tất cả vào thùng rác',
  thugui_daxoa: 'Thư gửi đã xóa',
  confirm_message_thungrac_mail: 'Bạn muốn chuyển thư vào thùng rác?',
  confirm_message_thungrac_all_mail: 'Bạn muốn chuyển tất cả thư vào thùng rác?',
  message_thungrac_mail: 'Đã chuyển thư vào thùng rác thành công!',
  noi_gui: 'Nơi gửi',
  can_empty: 'Có thể bỏ trống',
  butphe_lanhdao: 'Bút phê của lãnh đạo',
  ketquaxuly_nguoichutri: 'Kết quả xử lý của người chủ trì',
  thongtin_xuly: 'Thông tin xử lý',
  suathoihan: 'Sửa thời hạn',
  giaocapduoi: 'Giao cấp dưới',
  xulylai: 'Xử lý lại',
  thaydoithoihan: 'Thay đổi thời hạn',
  confirm_save_thoihan_question: 'Bạn muốn thay đổi thời hạn xử lý?',
  message_thoihan_success: 'Thay đổi thời hạn thành công!',
  message_delete_mail_thungrac: 'Thư đã được xóa khỏi thùng rác thành công!',
  confirm_question_delete_thungrac: 'Bạn muốn xóa thư khỏi thùng rác?',
  message_thoihan_error: 'Thời hạn phải lớn hơn ngày hiện tại!',
  message_xulylai_question: 'Nếu bạn bấm OK, Văn bản sẽ đặt trạng thái cho người nhận là chưa xem, chưa xử lý để xem yêu cầu xử lý lại của bạn. Bấm Cancel để hủy lệnh',
  message_xulylai_success: 'Đã thiết lập xử lý lại văn bản thành công!',
  view_vanban: 'Xem văn bản',
  thayfile_vanban: 'Thay file văn bản',
  thayfile_dinhkem: 'Thay file đính kèm',
  danhsachthuchien: 'Danh sách thực hiện',
  ketquaxuly: 'Kết quả xử lý',
  quahan: 'Quá hạn',
  taomoicuochop: 'Tạo mới cuộc họp',
  hethan: 'Hết hạn',
  conhan: 'Còn hạn',
  config_alert: 'Cấu hình cảnh báo',
  noidungcanhbao: 'Nội dung cảnh báo',
  songay: 'Số ngày',
  message_question_config: 'Bạn muốn lưu thông tin cấu hình cảnh bảo?',
  message_save_config_success: 'Bạn đã lưu thông tin cấu hình thành công!',
  btn_tieptheo: 'Tiếp theo',
  btn_truoc: 'Về trước',
  required: 'Những trường có dấu (*) là những trường bắc buộc',
  print_calendar: 'In lịch',
  share_by: 'Chia sẻ bởi',
  error_message_success: 'Người chủ trì đã chuyển trạng thái hoàn thành. Nên bạn không thể cập nhật hoặc hoàn thành công việc được nữa!',
  nguoixuly: 'Người xử lý',
  warning_share_lich: 'Không có thông tin lịch nào để chia sẽ!',
  ykien: 'Ý kiến',
  message_success_ykien: 'Đã lưu ý kiến thành công!',
  nhatkyxemlich: 'Nhật ký xem lịch',
  thoigianxemlandau: 'Thời gian xem lần đầu',
  xemlandau: 'Xem lần đầu:',
  xemlancuoi: 'Xem lần cuối:',
  thoigianxemlancuoi: 'Thời gian xem lần cuối',
  nhatky: 'Nhật ký',
  lichsuxemlich: 'Lịch sử xem lịch',
  daphatbieu: 'Đã phát biểu',
  chuaphatbieu: 'Chưa phát biểu',
  themnguoihop: 'Thêm người họp',
  question_save_phatbieu_ykien: 'Bạn muốn lưu nội dung phát biểu này?',
  message_phatbieu_ykien_success: 'Đã lưu thông tin phát biểu ý kiến thành công!',
  ykien_nguoichutri: 'Ý kiến người chủ trì',
  confirm_hoanthanh_meeting_question: 'Bạn phải chắc chắn mình muốn kết thúc cuộc họp. Nhấn Đồng ý để xác nhận kết thúc, Hủy để xem lại.',
  change_hoanthanh_meeting_success: 'Đã chuyển trạng thái kết thúc cuộc họp thành công!',
  error_message_meeting_success: 'Người chủ trì đã kết thúc cuộc họp. Nên bạn không thể cập nhật hoặc phát biểu ý kiến được nữa!',
  moihop: 'Mời họp',
  message_moihop_success: 'Đã mời họp thành công!',
  themthongtinnguoihop: 'Thêm thông tin người họp',
  themnguoinhantotrinh: 'Thêm người nhận tờ trình',
  themnguoinhanyeucau: 'Thêm người nhận yêu cầu',
  themnguoinhan: 'Thêm người nhận',
  message_add_nguoinhan_success: 'Đã thêm thông tin người nhận thành công!',
  luuykien: 'Lưu ý kiến',
  question_save_ykien: 'Bạn muốn lưu nội dung ý kiến này?',
  ykien_rieng: 'Ý kiến riêng',
  ghim_mail: 'Ghim thư lên đầu danh sách',
  huy_ghim_mail: 'Hủy ghim thư',
  message_question_ghim_mail: 'Bạn muốn ghim thư này?',
  message_success_ghim_mail: 'Đã ghim thư thành công',
  message_question_huy_ghim_mail: 'Bạn muốn hủy ghim thư này?',
  message_success_huy_ghim_mail: 'Đã hủy ghim thư thành công',
  thumucluutru: 'Thư mục lưu trữ',
  confirm_save_comment_question: 'Bạn muốn lưu ý kiến này?',
  ngayhethan: 'Ngày hết hạn',
  hoptiep: 'Tiếp tục họp',
  message_xulymeeting_question: 'Bạn muốn tiếp tục cuộc họp?',
  message_xulymeeting_success: 'Đã thiết lập trạng thái tiếp tục họp thành công!',
  message_thamkhao_question: 'Bạn muốn cho phép tham khảo ý kiến?',
  message_thamkhao_success: 'Đã cho phép tham khảo ý kiến thành công?',
  message_not_thamkhao_question: 'Bạn muốn không cho phép tham khảo ý kiến?',
  message_not_thamkhao_success: 'Đã bỏ quyền tham khảo ý kiến thành công?',
  select_unit_share: 'Chọn đơn vị chia sẻ',
  thongbao_khac: 'Các thông báo khác',
  noidungtrinh: 'Nội dung trình',
  noidungchuyentrinh: 'Nội dung chuyển trình',
  lichsusudung: 'Lịch sử sử dụng',
  loaidulieu: 'Loại dữ liệu',
  thaotac: 'Thao tác',
  chucnang: 'Chức năng',
  noidunggiaoviec: 'Nội dung giao việc',
  exportexcel: 'Xuất file excel',
  view_totrinh: 'Xem tờ trình',
  danhsachduocchon: 'Danh sách được chọn',
  butphe_success: 'Đã lưu bút phê thành công!',
  danhsachvanbanden_butphe: 'Danh sách bút phê văn bản đến',
  butphe_vanbanden: 'Bút phê văn bản',
  butphe_not: 'Chưa bút phê',
  butphe_ok: 'Đã bút phê',
  chon_nguoichutri: 'Chọn người chủ trì',
  error_selectstaffs_document: 'Vui lòng chọn người nhận',
  giaothem: 'Giao xử lý thêm',
  dinhnghiaquyen: 'Định nghĩa quyền hạn',
  nhomchucnang: 'Nhóm chức năng',
  chitiet_nhomchucnang: 'Chi tiết nhóm chức năng',
  tennhomchucnang: 'Tên nhóm chức năng',
  description: 'Mô tả',
  code_group: 'Mã nhóm',
  cauhinhchucnang: 'Cấu hình chức năng',
  cauhinhquyenhan: 'Cấu hình quyền hạn',
  phanquyenmodule: 'Phân quyền theo chức năng',
  phanquyenmenu: 'Phân quyền menu',
  kieumenu: 'Kiểu menu',
  chucnangchinh: 'Chức năng chính',
  soluong: 'Số lượng',
  totrinhnhan_hoanthanh: 'Tờ trình/ báo cáo nhận đã hoàn thành',
  yeucaudangsoan: 'Yêu cầu đang soạn',
  yeucaunhan_hoanthanh: 'Giao việc/ yêu cầu nhận đã hoàn thành',
  dagiaoxuly: 'Đã giao xử lý',
  confirm_destroy_xuly: 'Bạn muốn hủy người xử lý văn bản này?',
  message_destroy_xuly_success: 'Đã hủy thông itn người xử lý văn bản thành công!',
  destroy_xuly: 'Hủy xử lý',
  confirm_destroy_select: 'Vui lòng chọn người xử lý văn bản cần hủy?',
  thong_tin_canhbao: 'Thông tin cảnh báo',
  theo_cauhinh: 'Cấu hình',
  con_motngay: 'Một ngày',
  thoigian_canhbao: 'Thời gian cảnh báo',
  truoc_ngay: 'Trước ',
  sap_den_han: 'Sắp đến hạn',
  canhbao: 'Cảnh báo',
  luuycongviec: 'Lưu ý công việc',
  lichmoi: 'Lịch mới',
  thongbao_han_info: 'Nhập ngày hết hạn thì thông báo sẽ có hạn, nếu không nhập thì thông báo là vô hạn',
  thuviendientu: 'Thư viện điện tử',
  downloadall: 'Tải tất cả',
  login_title_header: 'CÔNG TY CỔ PHẦN VẬN TẢI ĐƯỜNG SẮT HÀ NỘI',
  login_title_header_end: 'HANOI RAILWAY TRANSPORT JOINT STOCK COMPANY',
  search_tuongdoi: 'Tìm tương đối',
  search_chinhxac: 'Tìm chính xác',
  search_type: 'Kiểu tìm kiếm',
  search_chude_tenguoigui: 'Tìm kiếm theo chủ đề, hoặc tên người gửi',
  error_nguoinhan: 'Thiếu thông tin người nhận thư!',
  vanbanchutri: 'Văn bản chủ trì',
  vanbanchutri_note: 'Nếu click button Văn bản chủ trì hệ thống sẽ hiển thị văn bản mà người dùng chủ trì '
};
